<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page028">
<div class="jstfy" id="page028_1">FROMAGE FRAIS</div>
<div class="jstfy" id="page028_2">TIME REQUIRED:</div>
<div class="jstfy" id="page028_3">B<span class="small">ecause this fresh</span> cheese has a very neutral flavour, it can be</div>
<div class="jstfy" id="page028_4">30 minutes</div>
<div class="jstfy" id="page028_5">used as a filling for different tarts.</div>
<div class="jstfy" id="page028_6">1 litre soya milk</div>
<div class="jstfy" id="page028_7">1.</div>
<div class="jstfy" id="page028_7a"><span class="page028_7a"> Combine the soya milk with the apple cider vinegar and lemon</span></div>
<div class="jstfy" id="page028_8">3 tsp apple cider vinegar</div>
<div class="jstfy" id="page028_9">juice in a pan and bring to the boil. Lower the heat and simmer for</div>
<div class="jstfy" id="page028_10">3 tsp lemon juice</div>
<div class="jstfy" id="page028_11">about 10 minutes, stirring constantly, until the mixture curdles.</div>
<div class="jstfy" id="page028_12">2.</div>
<div class="jstfy" id="page028_12a"><span class="page028_12a">Pour it into a large sieve lined with a cloth, and then twist the</span></div>
<div class="jstfy" id="page028_13">Salt, pepper</div>
<div class="jstfy" id="page028_14">ends of the cloth together. Keep squeezing the contents well until</div>
<div class="jstfy" id="page028_15">Vegan cream (optional)</div>
<div class="jstfy" id="page028_16">you’re left with a solid mass inside the cloth. Transfer the cheese</div>
<div class="jstfy" id="page028_17">to a bowl and season with salt and pepper. Mix in a little vegan</div>
<div class="jstfy" id="page028_18">cream, if desired.</div>
<div class="jstfy" id="page028_19">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page028_0">28</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_028.vue?588a7109